import noUiSlider from 'nouislider';

const RangeSlider = {

	selectors: {
		sliders: Array.prototype.slice.call(document.querySelectorAll('.js-range-slider')),
	},

	cssPrefix: 'c-range-slider-',

	filters: {
		'float': function(input) {
			return input;
		},
		'integer': function(input) {
			return Math.round(input);
		},
	},

	defaultFilter: 'float',

	init: function() {
		let self = this;

		self.selectors.sliders.forEach((slider) => {
			self.initSlider(slider);
		});
	},

	initSlider: function(_slider) {
		let self = this;

		let instance = noUiSlider.create(_slider, self.getSliderConfiguration(_slider));
		instance.on('update',function(values) {
			values = self.filterSliderValues(_slider, values);
			self.updateInputs(_slider, values);
			self.updatePreviews(_slider, values);
		});
	},

	getSliderConfiguration(_slider) {
		let self = this;

		return {
			start: [
				_slider.dataset.valueMin,
				_slider.dataset.valueMax,
			],
			connect: true,
			cssPrefix: self.cssPrefix,
			step: _slider.dataset.step === undefined ? 1 : parseFloat(_slider.dataset.step),
			range: {
				min: parseFloat(_slider.dataset.min),
				max: parseFloat(_slider.dataset.max),
			}
		};
	},

	filterSliderValues: function(_slider, _values) {
		let self = this;

		let filter;
		if (typeof self.filters[_slider.dataset.filter] === 'function') {
			filter = self.filters[_slider.dataset.filter];
		} else {
			filter = self.filters[self.defaultFilter];
		}

		return {
			min: filter(_values[0]),
			max: filter(_values[1]),
		}
	},

	updateInputs: function(_slider, values) {
		let self = this;

		self.setElementPropertyIfExist(_slider.dataset.inputSelectorMin, 'value', values.min);
		self.setElementPropertyIfExist(_slider.dataset.inputSelectorMax, 'value', values.max);
	},

	updatePreviews: function(_slider, values) {
		let self = this;

		self.setElementPropertyIfExist(_slider.dataset.previewSelectorMin, 'innerText', values.min);
		self.setElementPropertyIfExist(_slider.dataset.previewSelectorMax, 'innerText', values.max);
	},

	setElementPropertyIfExist: function(_selector, _property, _value) {
		let element = document.querySelector(_selector);
		if (element) {
			element[_property] = _value;
		}
	}
};

RangeSlider.init();
